'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('../constants');

// TODO - this is pretty much identical to introducer select (the instructors part is a direct copy)
// there must be a better way, but I don't have time... Ben M

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchingOccupations: false,
    fetchingIndustries: false,
    occupationsError: false,
    industriesError: false,
    occupations: undefined,
    industries: undefined
  };
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.FETCH_OCCUPATIONS + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          fetchingOccupations: true,
          occupationsError: false
        });
      }
    case _constants.actionTypes.FETCH_INDUSTRIES + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          fetchingInstructors: true,
          industriesError: false
        });
      }
    case _constants.actionTypes.FETCH_OCCUPATIONS + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        return Object.assign({}, state, {
          fetchingOccupations: false,
          occupationsError: false,
          occupations: action.payload
        });
      }
    case _constants.actionTypes.FETCH_INDUSTRIES + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        return Object.assign({}, state, {
          fetchingInstructors: false,
          industriesError: false,
          industries: action.payload
        });
      }
    case _constants.actionTypes.FETCH_OCCUPATIONS + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, {
          occupationsError: true
        });
      }
    case _constants.actionTypes.FETCH_INDUSTRIES + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, {
          industriesError: true
        });
      }
    case _constants.actionTypes.CLEAR_OCCUPATIONS:
      {
        return Object.assign({}, state, {
          occupations: undefined
        });
      }
    case _constants.actionTypes.CLEAR_INDUSTRIES:
      {
        return Object.assign({}, state, {
          industries: undefined
        });
      }
    default:
      return state;
  }
};